import { customRequestAjax } from '@/axiosApi'
import { buriedpointpath } from '../../../assets/common/js/config'

export function buildExposeItem(flow_area, item, effect_page) {
  var ad_text = ''
  var jump_type = ''
  var jump_value = ''
  if (item) {
    ad_text = item.ad_title || item.adtitle || item.name || item.noticecontent || ''
    jump_type = item.ad_type || item.adType || ''
    jump_value = item.ad_target || item.adTarget || ''
  }
  return {
    adCode: String(flow_area || ''),
    adText: String(ad_text),
    jumpType: String(jump_type),
    jumpValue: String(jump_value),
    exposureCount: '1',
    effectPage: String(effect_page || 'index')
  }
}

export function postAdExpose(list) {
  if (!list || !list.length) return
  list.forEach(item => {console.log('ckysdatacenter/AdExposure/save ',item.adCode)})
  customRequestAjax
    .post(buriedpointpath + 'ckysdatacenter/AdExposure/save', { exposure: list })
    .catch(function () {})
}



// WEBPACK FOOTER //
// ./src/components/homepage/js/adExposeReport.js